import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'

import SkeletonListRow from '../../../../../../features/components/List/Skeleton'
import PageSection from '../../../../../../features/components/PageSection'
import List from '../../../../../../features/components/List'
import ItemsLoading from '../../../../../../components/Loaders/ItemsLoading'
import Chip from '../../../../../../components/Chip'
import ActionsDropdown from '../../../../../../features/components/ActionsDropdown'

import useAssetGroupsActions from './useAssetGroupsActions'
import { insertIf } from '../../../../../../helpers/common'
import { getStatusTagColor } from '../../../../../../features/helpers/componentsHelpers'

import {
  assetGroupsErrorSelector,
  assetGroupsIsLoadingSelector,
  assetGroupsSelector,
  assetGroupsWasLoadedSelector,
  updateAssetGroupIdSelector,
  updateAssetGroupIsLoadingSelector
} from '../../../../../../modules/selectors/assets'

import {
  listItemsTableColumnsMaxWidth,
  listItemsTableColumnsMinWidth
} from '../../../../../../features/components/ListItemsTable/columnsWidth'

import useStyles from './styles'

const AssetGroupsList = () => {
  const classes = useStyles()

  const assetGroups = useSelector(assetGroupsSelector)
  const updateAssetGroupId = useSelector(updateAssetGroupIdSelector)
  const updateAssetGroupIsLoading = useSelector(updateAssetGroupIsLoadingSelector)

  const getAssetGroupsActionDropdownOptions = useAssetGroupsActions()

  const itemsListColumns = useMemo(
    () => [
      {
        headTitle: 'Name',
        field: 'name',
        style: {
          minWidth: listItemsTableColumnsMinWidth.name
        }
      },
      {
        Component: ({ status }) => {
          return <Chip text={status} color={getStatusTagColor(status)} />
        },
        style: {
          minWidth: listItemsTableColumnsMinWidth.status,
          maxWidth: listItemsTableColumnsMaxWidth.status,
          textOverflow: 'unset'
        }
      },
      // if actions menu is empty then hide it
      ...insertIf(!!getAssetGroupsActionDropdownOptions({}).length, {
        Component: item => <ActionsDropdown options={getAssetGroupsActionDropdownOptions(item)} />,
        style: {
          minWidth: listItemsTableColumnsMinWidth.dropdown,
          maxWidth: listItemsTableColumnsMinWidth.dropdown,
          padding: 0
        }
      })
    ],
    [getAssetGroupsActionDropdownOptions]
  )

  const skeletonProps = useMemo(() => ({ cols: itemsListColumns }), [itemsListColumns])

  return (
    <ItemsLoading
      className={classes.list}
      itemsLength={assetGroups.length}
      SkeletonComponent={SkeletonListRow}
      skeletonProps={skeletonProps}
      errorSelector={assetGroupsErrorSelector}
      isLoadingSelector={assetGroupsIsLoadingSelector}
      wasLoadedSelector={assetGroupsWasLoadedSelector}
      ContentWrapper={PageSection}
    >
      <List
        cols={itemsListColumns}
        listData={assetGroups}
        itemUpdatingId={updateAssetGroupIsLoading ? updateAssetGroupId : ''}
        Skeleton={<SkeletonListRow {...skeletonProps} key={uuidv4()} />}
        isBigRow
      />
    </ItemsLoading>
  )
}

export default AssetGroupsList
